package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource

data class RuleExample(
    val gardinerCode: String,
    val translation: StringResource? = null
)

data class RuleCard(
    val text: StringResource,
    val examples: List<RuleExample> = emptyList()
)

data class CompendioRuleItem(
    val id: String,
    val lessonId: String,
    val title: StringResource,
    val hiero: String,
    val cards: List<RuleCard>
)
